// extracted by mini-css-extract-plugin
export var dropdown = "_g8-0";
export var imagePlaceholder = "_g8-2";
export var imageWrapper = "_g8-3";
export var productImage = "_g8-1";
export var truncateContainer = "_g8-4";
export var truncateText = "_g8-5";